export enum GraphTypes {
  Chart,
  List,
}
